import Download from '@mui/icons-material/Download';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  IconButton,
  Button
} from '@mui/material';
import { useDownload } from '../../../Utils/Download/useDownload';
import IconReusable from '../../../../components/IconReusable';
import { downloadCertificate } from '../APIs/action';
import { useState } from 'react';

const TDSTable = ({ breakdown }) => {
    const excludedKeys = ["start_date", "end_date"];
    const [isLoading, setIsLoading] = useState(false);
    const filteredHeaders = breakdown.table_header_keys.filter(
        (col) => !excludedKeys.includes(col.value)
    );
    const filteredRows = breakdown.table_list_dtos.map((row) => {
        const newRow = {};
        Object.keys(row).forEach((key) => {
        if (!excludedKeys.includes(key)) newRow[key] = row[key];
        });
        return newRow;
    });
    const handleDownloadCertificate = async (period_start_date, period_end_date, fileName) => {
        if (isLoading) return;
        try {
        setIsLoading(true);
        const downloadPromise = downloadCertificate(
            period_start_date,
            period_end_date,
            fileName
        );
        const minDelayPromise = new Promise(resolve => setTimeout(resolve, 1000));
        
        await Promise.all([downloadPromise, minDelayPromise]);
        
        const isInWebView = window.navigator.userAgent.includes('wv') || 
                            window.navigator.standalone || 
                            window.matchMedia('(display-mode: standalone)').matches;
        
        if (isInWebView) {
            console.log('Download initiated successfully');
        }
        } catch (error) {
        console.error('Download failed:', error);
        } finally {
        setIsLoading(false);
        }
    };

  return (
    <Box>

      <TableContainer
        component={Paper}
        sx={{
          boxShadow: "none",
          border: "1px solid #E5E5E5",
          borderRadius: 2,
          p: 2,
          pb: 1,
          backgroundColor: "#FFFFFF",
        }}
      >
        <Table sx={{ p: 1 }}>
          <TableHead>
            <TableRow>
              {filteredHeaders.map((header, index) => (
                <TableCell
                  key={index}
                  sx={{
                    borderBottom: 'none',
                    textAlign: index === 0 ? "start" : "center",
                    py: "8px",
                    pl: index === 0 ? 0 : undefined,
                  }}
                >
                  <Typography variant="h3" sx={{ color: '#8C8C8C'}}>{header.label}</Typography>
                </TableCell>
              ))}
              <TableCell
                sx={{
                  textAlign: "center",
                  borderBottom: 'none',
                  py: "8px"
                }}
              >
                <Typography variant="h3" sx={{ color: '#8C8C8C'}}>Certificate</Typography>
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {breakdown.table_list_dtos.map((originalRow, rowIndex) => {
              const filteredRow = filteredRows[rowIndex];
              return (
                <TableRow key={rowIndex}>
                  {filteredHeaders.map((header, colIndex) => (
                    <TableCell
                      key={colIndex}
                      sx={{
                        borderBottom:
                          rowIndex === breakdown.table_list_dtos.length - 1
                            ? "none"
                            : "1px solid #E5E5E5",
                        py: "8px",
                        textAlign: colIndex === 0 ? "start" : "center",
                        pl: colIndex === 0 ? 0 : undefined,
                      }}
                    >
                      <Typography variant="p3">
                        {filteredRow[header.value] || "-"}
                      </Typography>
                    </TableCell>
                  ))}
                  <TableCell
                    sx={{
                      borderBottom:
                        rowIndex === breakdown.table_list_dtos.length - 1
                          ? "none"
                          : "1px solid #F2F2F2",
                      py: "8px",
                      textAlign: "center"
                    }}
                  >
                    <IconButton
                      onClick={() => handleDownloadCertificate(
                        originalRow.start_date,
                        originalRow.end_date,
                        `TDS_Certificate.pdf`
                      )}
                    >
                      <IconReusable color='#995A00' name='DownloadOutlined' width={20} height={20} />
                    </IconButton>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default TDSTable;
